import { routes } from "../constants/routes";

// export function getUTCString(dateObj) {
//   const y = dateObj.getUTCFullYear();
//   let m = dateObj.getUTCMonth() + 1;
//   let d = dateObj.getUTCDate();
//   let h = dateObj.getUTCHours();
//   let min = dateObj.getUTCMinutes();
//   if (m < 10) {
//     m = "0" + m;
//   }
//   if (d < 10) {
//     d = "0" + d;
//   }
//   if (h < 10) {
//     h = "0" + h;
//   }
//   if (min < 10) {
//     min = "0" + min;
//   }

//   return `${y}-${m}-${d}T${h}:${min}:00.000Z`;
// }

// export function formatDateTimeFromISO(timestamp) {
//   if (!timestamp) return "";
//   const date = new Date(timestamp);
//   const year = date.getUTCFullYear();
//   const month = `0${date.getUTCMonth() + 1}`.slice(-2);
//   const day = `0${date.getUTCDate()}`.slice(-2);
//   const hours = `0${date.getUTCHours()}`.slice(-2);
//   const minutes = `0${date.getUTCMinutes()}`.slice(-2);
//   const seconds = `0${date.getUTCSeconds()}`.slice(-2);
//   return `${year}-${month}-${day} ${hours}:${minutes}:${seconds} UTC`;
// }

// export function formatDate(timestamp) {
//   if (!timestamp) return "";
//   const date = new Date(timestamp);
//   const year = date.getUTCFullYear();
//   const month = `0${date.getUTCMonth() + 1}`.slice(-2);
//   const day = `0${date.getUTCDate()}`.slice(-2);
//   return `${year}-${month}-${day}`;
//   // const hours = `0${date.getUTCHours()}`.slice(-2);
//   // const minutes = `0${date.getUTCMinutes()}`.slice(-2);
//   // const seconds = `0${date.getUTCSeconds()}`.slice(-2);
//   //return `${year}-${month}-${day} ${hours}:${minutes}:${seconds} UTC`;
// }

export function formatDateENGB(timestamp) {
  if (!timestamp) return "";
  const date = new Date(timestamp);
  return date.toLocaleDateString("en-GB");
  // const hours = `0${date.getUTCHours()}`.slice(-2);
  // const minutes = `0${date.getUTCMinutes()}`.slice(-2);
  // const seconds = `0${date.getUTCSeconds()}`.slice(-2);
  //return `${year}-${month}-${day} ${hours}:${minutes}:${seconds} UTC`;
}

export const addDefaultImg = (e) => {
  e.target.src = routes.DEFAULT_IMAGE;
};
export const addUserDefaultImg = (e) => {
  e.target.src = routes.DEFAULT_USER_IMAGE;
};
export const addUserDefaultImg2 = (e) => {
  e.target.src = routes.DEFAULT_USER_IMAGE2;
};

export function formatAmount(amount) {
  if (!amount) return parseFloat(0).toFixed(2);
  return parseFloat(amount).toFixed(2);
}

export function handleConsoleError(error, context = "") {
  if (process.env.NODE_ENV !== "production") {
    console.error("Error:", context, error);
  }

  // Send error details to backend or logging service
  // sendErrorToServer(error, context);

  return "Something went wrong. Please try again.";
}
